import React, { useState, useEffect } from "react";
import Cookies from "js-cookie";
import { Modal, Table } from "antd";
// import Api from "../../../../services/ServiceApi";
import axios from "axios";
import { SAPInterfaceAPI } from "../../../../config";
export default function ModalSiteCodeSelect({
  areacode,
  inputSite,
  ModalShow,
  setModalShow,
  autoAssingSite,
}) {
  const colunmSite = [
    {
      title: "Site Code",
      dataIndex: "siteCode",
      key: "",
    },
    {
      title: "Site Name",
      dataIndex: "siteName",
      key: "",
    },
    {
      title: "Site Grade",
      dataIndex: "gradeSite",
      key: "",
    },
    {
      title: "Latitude",
      dataIndex: "latitude",
      key: "",
      render: (text) => {
        if (text !== null) {
          return <span>{text}</span>;
        } else {
          return <span>-</span>;
        }
      },
    },
    {
      title: "Longtitude",
      dataIndex: "longitude",
      key: "",
      render: (text) => {
        if (text !== null) {
          return <span>{text}</span>;
        } else {
          return <span>-</span>;
        }
      },
    },
    {
      title: "Area",
      dataIndex: "center",
      key: "",
      render: (text) => {
        if (text !== null) {
          return <span>{text}</span>;
        } else {
          return <span>-</span>;
        }
      },
    },
    {
      title: "Select",
      dataIndex: "",
      key: "",
      width: 60,
      fixed: "right",
      render: (item) => {
        return (
          <div
            style={{ cursor: "pointer" }}
            onClick={() =>
              autoAssingSite(
                item.siteCode,
                item.siteName,
                item.gradeSite,
                item.latitude,
                item.longitude,
                item.center
              )
            }
          >
            <i className="fas fa-check-circle c-green"></i>
          </div>
        );
      },
    },
  ];

  const [isLoading, setisLoading] = useState(false);
  const [errorCode, seterrorCode] = useState("error");
  const [noData, setnoData] = useState(false);
  const [siteDetail, setsiteDetail] = useState([
  ]);
  useEffect(() => {
    setisLoading(true);
    axios
      .post(
        SAPInterfaceAPI + "GetSiteMasterDetails",
        {
          company: Cookies.get("companyid"),
          center: areacode || "", //ใช้ area code
          searchSite: String(inputSite),
        },
        {
          headers: {
            "Content-type": "application/json",
            TokenUser: Cookies.get(`OperationToken`),
          },
        }
      )
      .then((res) => {
        if (res.data?.result.value === "P") {
          setsiteDetail(res.data.list);
          setnoData(false);
          setisLoading(false);
        } else if (res.data?.result.value === "F") {
          setnoData(true);
          setisLoading(false);
          seterrorCode(res.data?.result.showText);
        }
      })
      .catch((err) => {
        setnoData(true);
        setisLoading(false);
        seterrorCode(err);
      });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputSite]);

  const onClose = () => {
    setModalShow(false);
  };
  return (
    <>
      <Modal
        title={`Please select site`}
        centered
        visible={ModalShow}
        footer={null}
        onCancel={onClose}
        className="custom-modal-map-large"
      >
        <div className="col-12 mx-auto">
          {noData ? (
            <div className="row d-flex justify-content-center mt-4">
              <span className="font-thai-r fs-18 mb-4 c-red">{errorCode}</span>
            </div>
          ) : (
            <Table
              scroll={{ y: 300, x: 1000 }}
              sizexxx="small"
              loading={isLoading}
              columns={colunmSite}
              dataSource={siteDetail}
            ></Table>
          )}
        </div>
      </Modal>
    </>
  );
}
